export const baseUrl = 'https://loyaltysintexapi.evolve-brands.co/api/v1/'
export const av = "1.0";
export const pt = "WEBSITE";
export const company = "1"
export const program = "1"
export const program2 = "2"